import React, { useState } from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router";
import { pdfjs, Document, Page } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

import * as styles from "./GeneratedPDF.module.css";

export const GeneratedPDF = () => {
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setLoading(false);
  };

  const goToPrevPage = () => {
    setPageNumber((prev) => Math.max(prev - 1, 1));
  };

  const goToNextPage = () => {
    setPageNumber((prev) => Math.min(prev + 1, numPages));
  };

  const handleSignWithESignature = () => {
    // navigate('/e-signature');
    console.log("Sign with e-signature clicked");
    setShowModal(true);
  };

  return (
    <div className={styles.wrapper}>
      {showModal && (
        <div
          className={styles.modalWrapper}
          onClick={() => {
            navigate("/dashboard");
          }}
        >
          <div className={styles.modal}>
            <h1>Успешно подписано!</h1>
          </div>
        </div>
      )}

      <div className={styles.header}>
        <h2>Предпросмотр документа</h2>
        <Button
          label="Подписать ЭЦП"
          icon="pi pi-pencil"
          className="p-button-success"
          style={{ backgroundColor: "#2ECC71" }}
          onClick={handleSignWithESignature}
        />
      </div>

      <div className={styles.pdfContainer}>
        <Document
          file="./DemoAct.pdf"
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<div>Loading PDF...</div>}
        >
          <Page
            pageNumber={pageNumber}
            renderTextLayer={true}
            renderAnnotationLayer={true}
            width={800}
          />
        </Document>

        <div className={styles.controls}>
          <Button
            icon="pi pi-chevron-left"
            className={styles.paginationBtn}
            onClick={goToPrevPage}
            disabled={pageNumber <= 1}
          />
          <p>
            {pageNumber} из {numPages || "?"}
          </p>
          <Button
            icon="pi pi-chevron-right"
            className={styles.paginationBtn}
            onClick={goToNextPage}
            disabled={pageNumber >= numPages}
          />
        </div>
      </div>
    </div>
  );
};
